import { ShadowBorderContainer, Text } from '../../../tw-components';
import nextStepsIcon from '../../../../../images/next-steps-icon.svg';

export const HelpSection = () => {
  return (
    <div className="tw-flex tw-gap-x-4 tw-mb-3">
      <ShadowBorderContainer className="tw-w-full tw-flex tw-flex-col sm:tw-flex-row tw-gap-x-2">
        <div className="tw-flex tw-w-full sm:tw-w-1/4 items-center tw-justify-center md:tw-w-1/4 tw-mb-2">
          <img
            className="tw-flex tw-w-1/3 sm:tw-w-full"
            src={nextStepsIcon}
            alt="Support Icon"
          ></img>
        </div>
        <div className="tw-w-full md:tw-w-3/4">
          <Text
            className="tw-mb-3 tw-font-semibold tw-text-center sm:tw-text-left"
            color="unm-interactive01-400"
          >
            Next Steps
          </Text>
          <Text className="tw-mb-3 tw-text-center sm:tw-text-left">
            If documentation is needed for your case, you will receive Tasks and
            Letters (found on the Overview tab) with any needed documents.
          </Text>
          <Text className="tw-text-center sm:tw-text-left">
            If you need to make updates to your request or provide Unum with
            additional information, please use the Quick Links on the righthand
            side of the page (or the hamburger icon in the top right if using a
            mobile device).
          </Text>
        </div>
      </ShadowBorderContainer>
    </div>
  );
};
